import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomReplyAlt = createSvgIcon(
  <path d="M14 9V5l7 7-7 7v-4.1c-5 0-8.5 1.6-11 5.1 1-5 4-10 11-11" />,
  'CustomReplyAlt',
);

export default CustomReplyAlt;
